import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { SubmitBatchParticipationInvoiceBody } from "@shared-kernel/application/ports/educational-advisor/educational-advisor-repository";

export const submitBatchParticipationInvoice = createAsyncThunk<
  void,
  SubmitBatchParticipationInvoiceBody,
  { extra: Partial<Dependencies> }
>(
  "batches/submitBatchParticipationInvoice",
  async (body: SubmitBatchParticipationInvoiceBody, { extra: { educationalAdvisorRepository } }) => {
    return educationalAdvisorRepository!.submitParticipationInvoice(body);
  },
);

export const resetSubmitBatchParticipationInvoice = createAction("batches/resetSubmitBatchParticipationInvoice");
